import React from 'react';
import type {
  ComponentProps,
  TranscriptPromptElement,
} from '../../../types/aha-editor';
import styles from './Transcript.module.css';

interface TranscriptPromptComponentProps
  extends ComponentProps<TranscriptPromptElement> {}

const TranscriptPromptComponent: React.FC<
  React.PropsWithChildren<TranscriptPromptComponentProps>
> = ({ attributes, element, children }) => {
  return (
    <div
      {...attributes}
      className={styles.prompt}
      data-transcript-prompt-id={element.prompt_id}
    >
      {children}
    </div>
  );
};

export default TranscriptPromptComponent;
